import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, ListHeader, ReceivablesPrincipals, ReceivablesFeeTaxes, ReceivablesCertainPeriod, ReceivablesByMaturity } from 'components';
import { showApiError } from 'utils';
import { getAllFranchises } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Receivables = function Receivables(_ref) {
  var match = _ref.match;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      franchises = _useState2[0],
      setFranchises = _useState2[1];

  useEffect(function () {
    fetchFranchises();
  }, []);

  var fetchFranchises = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllFranchises();

            case 2:
              _yield$getAllFranchis = _context.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFranchises(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFranchises() {
      return _ref2.apply(this, arguments);
    };
  }();

  var PrincipalsTab = useCallback(function () {
    return ___EmotionJSX(ReceivablesPrincipals, {
      franchises: franchises
    });
  }, [franchises]);
  var FeeTaxesTab = useCallback(function () {
    return ___EmotionJSX(ReceivablesFeeTaxes, {
      franchises: franchises
    });
  }, [franchises]);
  var CertainPeriodTab = useCallback(function () {
    return ___EmotionJSX(ReceivablesCertainPeriod, {
      franchises: franchises
    });
  }, [franchises]);
  var ByMaturityTab = useCallback(function () {
    return ___EmotionJSX(ReceivablesByMaturity, {
      franchises: franchises
    });
  }, [franchises]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u0412\u0437\u0435\u043C\u0430\u043D\u0438\u044F"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/receivables-principals",
    component: PrincipalsTab,
    label: "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/receivables-fee-taxes",
    component: FeeTaxesTab,
    label: "\u041B\u0438\u0445\u0432\u0438 \u0438 \u0442\u0430\u043A\u0441\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/receivables-certain-period",
    component: CertainPeriodTab,
    label: "\u0417\u0430\u0434\u0435\u043D \u043F\u0435\u0440\u0438\u043E\u0434"
  }), ___EmotionJSX(Tab, {
    url: "/receivables-by-maturity",
    component: ByMaturityTab,
    label: "\u0412\u0437\u0435\u043C\u0430\u043D\u0438\u044F \u043F\u043E \u043F\u0430\u0434\u0435\u0436"
  })));
};

Receivables.propTypes = {
  match: PropTypes.object
};
export default Receivables;